import { getJsonPathValue } from '@carboncopyco/editor-utils';
import { update } from 'lodash-es';
import { FormField } from './FormField';
import type { BaseJsonForm } from './types';
import { shouldTakeUpRemainingSpace } from './utils';

export const JsonFormPresentation = ({ value, onChange }: BaseJsonForm) => {
  return (
    <div>
      {value.fields.map((field) => {
        let fieldValue;
        try {
          fieldValue = getJsonPathValue(value.json, field.jsonPath);
        } catch (error) {
          console.log(error);
          return null;
        }

        return (
          <FormField
            key={field.jsonPath}
            field={field}
            shouldTakeUpRemainingSpace={shouldTakeUpRemainingSpace(
              value.fields
            )}
            value={fieldValue}
            onChangeValue={(newValue) => {
              const updatedValue = structuredClone(value);
              update(updatedValue.json, field.jsonPath, () => newValue);
              onChange(updatedValue);
            }}
          />
        );
      })}
    </div>
  );
};
